/**
 * Menu and navigation color definitions
 */
import { palette, createColor } from './palette.colors';

export const dashboardMenuColors = {
  iconColor: createColor(palette.gray.dark, palette.gray.dark),
  selectedIconColor: createColor(palette.blue.primary, palette.blue.primary),
};

export const helpMenuColors = {
  iconColor: createColor(palette.gray.darker, palette.gray.darker),
  selectedIconColor: createColor(palette.gray.darker, palette.gray.darker),
};

export const profileMenuColors = {
  iconBG: createColor(palette.gray.light, palette.dark.content),
  BGColor: createColor(palette.gray.light, palette.dark.content),
  textColor: createColor(palette.gray.almostBlack, palette.dark.text),
};

export const notificationMenuColors = {
  iconColor: createColor(palette.gray.darker, palette.gray.darker),
  selectedIconColor: createColor(palette.gray.darker, palette.gray.darker),
};

export const menuLayoutColors = {
  divider: createColor(palette.opacity.black13, palette.opacity.black13),
  bottomDivider: createColor(palette.gray.border, palette.dark.borderLight)
};

export const mainLayoutColors = {
  shadowColor: createColor(palette.special.shadow, palette.special.shadow),
  BGColor: createColor(palette.gray.lightWhite, palette.gray.lightWhite),
};

export const indirectActivityColors = {
  iconColor: createColor(palette.gray.darker, palette.dark.textAlt),
  CTABorder: createColor(palette.gray.border, palette.dark.borderLight),
  CTAIcon: createColor(palette.gray.black, palette.gray.black),
  CTAText: createColor(palette.gray.darkest, palette.dark.text),
  modalOverlay: createColor(palette.opacity.black60, palette.opacity.black60),
  confirmationText: createColor(palette.gray.textSubtle, palette.gray.textSubtle),
  selectedActivityBorder: createColor(palette.gray.neutral, palette.dark.borderLight),
  selectedActivityBackground: createColor(
    palette.gray.veryLight,
    palette.dark.content,
  ),
  selectedActivityText: createColor(palette.gray.darkest, palette.dark.text),
  selectedActivityTitle: createColor(palette.gray.dark, palette.dark.textAlt),
  lightBackground: createColor(palette.opacity.black20, palette.opacity.black20),
};

export const quickAssitColors = {
  iconColor: createColor(palette.gray.darker, palette.dark.textAlt),
  CTABorder: createColor(palette.gray.border, palette.dark.borderLight),
  CTAIcon: createColor(palette.gray.black, palette.gray.black),
  CTAText: createColor(palette.gray.darkest, palette.dark.text),
};


export const selectedShopColors = {
  BG: createColor(palette.blue.sky, palette.blue.sky),
  textColor: createColor(palette.blue.sky, palette.blue.sky),
};